export const LOCAL_STORAGE_USER_ID_KEY = '___$orama_user_id$___';
export const DEFAULT_SERVER_USER_ID = 'ssid';
